import React from 'react';
import styled from 'styled-components';
import propTypes from '../common/prop-types';

const Container = styled.div`
  background-color: #F1F3F8;
  min-height: 270px;

  ${props => props.showInModal && `
    border-radius: 15px 15px 0px 0px;
    border-top: 1px solid #53627c;
  `};

  &.income-series {
    background-color: unset;
    background-image: url('${props => props.incomeSeriesBackground}');
    background-repeat: round;
    background-size: cover;

    ${props => props.theme.isMobile && `
      background-image: url('${props.incomeSeriesBackground}');
    `};
  }

  &.top-rated {
    background-color: unset;
    background-image: url('${props => props.topRatedFundSeriesDesktopBackground}');
    background-repeat: round;
    background-size: cover;

    ${props => props.theme.isMobile && `
      background-image: url('${props.topRatedFundSeriesMobileBackground}');
    `};
  }

  ${props => props.theme.isMobileOrTablet && `
    min-height: 130px;
    margin-top: 0;
  `};

  ${props => props.theme.isMobile && !props.showInModal && `
    min-height: 95px;
  `};

  > div {
    display: flex;
    width: 100%;
    margin: 0 auto;
    justify-content: space-between;

    ${props => props.theme.isXLarge && `
      max-width: 1015px;
    `};

    ${props => props.theme.isXXLarge && `
      max-width: 1250px;
    `};
  }
`;

const BreadcrumbContainer = styled.div`
  margin: 0 auto;
  padding: 0 20px;
  width: 100%;

  ${props => props.theme.isLarge && `
    padding: 0 32px;
  `};

  ${props => props.theme.isMobileOrTablet && !props.theme.isMobile && `
    padding: 0 28px;
  `};

  ${props => props.theme.isMobile && `
    overflow-x: auto;
    scrollbar-color: #8ea3b5;
  `};
`;

const Logo = styled.img`
  position: ${props => (props.showInModal ? 'relative' : 'absolute')};
  max-width: 80px;

  ${props => props.showInModal && `
    height: 60px;
  `};

  ${props => props.theme.isMobile && `
    top: ${(props.showInModal ? 60 : 100)}px;
    right: 20px;
    max-width: 66px;
  `};

  ${props => props.theme.isTablet && `
    top: ${(props.showInModal ? 50 : 120)}px;
    right: 28px;
  `};

  ${props => props.theme.isLarge && `
    top: ${(props.showInModal ? 50 : 100)}px;
    right: 32px;
  `};

  ${props => props.theme.isXLarge && `
    top: ${(props.showInModal ? 30 : 150)}px;
    right: calc(50% - 472px);
  `};

  ${props => props.theme.isXXLarge && `
    right: calc(50% - 592px);
  `}

  &.income-series {
    max-width: 60px;

    ${props => props.theme.isMobile && `
      top: ${(props.showInModal ? 60 : 80)}px;
    `};

    ${props => props.theme.isTablet && `
    top: ${(props.showInModal ? 60 : 100)}px;
      max-width: 64px;
    `};

    ${props => props.theme.isLarge && `
      top: ${(props.showInModal ? 40 : 90)}px;
    `};

    ${props => props.theme.isXLarge && `
      top: ${(props.showInModal ? 30 : 150)}px;
    `};
  }
`;

export default function Hero(props) {
  const {
    fund: {
      isInIncomeSeries,
      isInTopRatedFundsSeries,
    },
    showInModal,
    topRatedFundSeriesDesktopBackground,
    topRatedFundSeriesMobileBackground,
    topRatedFundSeriesLogo,
    incomeSeriesBackground,
    incomeSeriesLogo,
    breadcrumb,
  } = props;

  // eslint-disable-next-line no-nested-ternary
  const className = isInIncomeSeries ? 'income-series' : isInTopRatedFundsSeries ? 'top-rated' : '';
  const logo = isInIncomeSeries ? incomeSeriesLogo : topRatedFundSeriesLogo;

  return (
    <Container
      showInModal={showInModal}
      topRatedFundSeriesDesktopBackground={topRatedFundSeriesDesktopBackground}
      topRatedFundSeriesMobileBackground={topRatedFundSeriesMobileBackground}
      incomeSeriesBackground={incomeSeriesBackground}
      className={className}
    >
      <div>
        <BreadcrumbContainer
          dangerouslySetInnerHTML={{ __html: breadcrumb }}
          showInModal={showInModal}
        />

        {(isInIncomeSeries || isInTopRatedFundsSeries) && (
          <Logo
            className={className}
            src={logo}
            showInModal={showInModal}
          />
        )}
      </div>

    </Container>
  );
}

Hero.propTypes = propTypes;
